import Guid from "common/values/guid/guid";
import Name from "common/values/name/name";

export interface UserInfoJSON {
  userId: string;
  individualId: string;
  name: string;
  avatarUrl?: string;
  entityId: string;
  companyId: string;
  companyName: string;
}

export default class UserInfo {
  userId: Guid;
  individualId: Guid;
  name: Name;
  avatarUrl?: string;
  entityId: Guid;
  companyId: Guid;
  companyName: string;

  constructor(
    userId: Guid,
    individualId: Guid,
    name: Name,
    entityId: Guid,
    companyId: Guid,
    companyName: string,
    avatarUrl?: string
  ) {
    this.userId = userId;
    this.individualId = individualId;
    this.name = name;
    this.avatarUrl = avatarUrl;
    this.entityId = entityId;
    this.companyId = companyId;
    this.companyName = companyName;
  }

  public clone(): UserInfo {
    return new UserInfo(
      this.userId,
      this.individualId,
      this.name,
      this.entityId,
      this.companyId,
      this.companyName,
      this.avatarUrl
    );
  }

  public toJSON(): UserInfoJSON {
    return {
      userId: this.userId.toString(),
      individualId: this.individualId.toString(),
      name: this.name.toString(),
      avatarUrl: this.avatarUrl,
      entityId: this.entityId.toString(),
      companyId: this.companyId.toString(),
      companyName: this.companyName
    };
  }

  public static fromJSON(json: UserInfoJSON): UserInfo {
    return new UserInfo(
      Guid.fromJSON(json.userId),
      Guid.fromJSON(json.individualId),
      new Name(json.name),
      Guid.fromJSON(json.entityId),
      Guid.fromJSON(json.companyId),
      json.companyName,
      json.avatarUrl
    );
  }
}
